import { BitfGraphQlEnvelopeMapper } from '../graph-ql-parser/bitf-graph-ql-envelope.mapper';

export class BitfStrapiGraphQlEnvelopeMapper extends BitfGraphQlEnvelopeMapper {
  constructor() {
    super();
  }
}
